// extracted by mini-css-extract-plugin
export default {"favButton":"AddToFavoritesButton_favButton__6oH3u"};